"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptTime;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _moment = _interopRequireDefault(require("moment"));
var _VisitTypeContent = _interopRequireDefault(require("./VisitTypeContent"));
var _States = require("../../lib/constants/States");
var _styles = require("./styles");
var _Actions = require("../../lib/constants/Actions");
var _ProviderLocations = _interopRequireDefault(require("../ProviderLocations"));
var _ApptList = _interopRequireDefault(require("./ApptList"));
var _Loading = _interopRequireDefault(require("./Loading"));
var _Banners = require("../Banners");
var _Recaptcha = require("../Recaptcha");
var _utils = require("../../lib/utils");
var _configUtils = require("../../lib/configUtils");
var _Tracking = require("../../lib/constants/Tracking");
var _CollapsibleFilters = require("./CollapsibleFilters");
var _TimeFilter = require("./TimeFilter");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// if we ask for 8:30 we may get a result that's
// between 8:00-8:30 and end up in an infinite loop.
// Asking for 8:31 will return 8:30-9:00
const nextPeriodStart = appointments => (0, _moment.default)(appointments[appointments.length - 1].end_datetime).add(1, 'minute');
const propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  config: (0, _propTypes.shape)({
    recaptchaSiteKey: _propTypes.string
  }).isRequired,
  track: _propTypes.func.isRequired,
  mapApiKey: _propTypes.string,
  apptDensity: (0, _propTypes.oneOf)(['default', 'dense']),
  onScroll: _propTypes.func,
  offsetTop: _propTypes.number,
  awsMapConfig: _propTypes.object
};
const defaultProps = {
  mapApiKey: null
};
function ApptTime(_ref) {
  var _context;
  let {
    service,
    config,
    track,
    mapApiKey,
    apptDensity,
    onScroll,
    offsetTop,
    awsMapConfig
  } = _ref;
  const [state, send] = (0, _react2.useService)(service);
  const [highlightedLocId, setHighLightedLocId] = (0, _react.useState)(null);
  const {
    appointments,
    query,
    provider,
    locsByAvailability,
    locationId,
    // deep-linked location id if it exists
    filterBy,
    jumpedToDate,
    filterCount
  } = state.context;
  (0, _react.useEffect)(() => {
    if (state.matches(`${_States.jumpToDate}.${_States.noResults}`)) {
      track(_Tracking.userEvents.APPT_JUMP_TO_DATE_NO_RESULTS);
    }
    if (state.matches(`${_States.newSearch}.${_States.noResults}`) || state.matches(`${_States.loadingAvailableLocs}.${_States.loadingAvailableLocsError}`)) {
      track(_Tracking.userEvents.APPT_NO_RESULTS);
    }
    if (state.matches(`${_States.newSearch}.${_States.deepLinkingTimeSlotUnavailableError}`)) {
      track(_Tracking.deepLinkingEvents.TIME_SLOT_UNAVAILABLE_ERR);
    }
  }, [state, track]);
  const isFetchingAltProviders = state.matches(_States.fetchingAltProviders);
  const isLoadingAvailableLocsPending = state.matches(`${_States.loadingAvailableLocs}.${_States.pending}`);
  const isNewSearchPending = (0, _some.default)(_context = [`${_States.newSearch}.${_States.pending}`, `${_States.jumpToDate}.${_States.pending}`]).call(_context, state.matches);
  const isPendingEhrPatientDemographics = state.matches(`${_States.pendingEhrPatientDemographics}`);
  const isNewSearchRouting = state.matches(`${_States.newSearch}.${_States.routing}`);
  const isCheckingCaptchaSession = state.matches(`${_States.newSearch}.${_States.checkingCaptchaSession}`);
  const getMapZoomRefOnLoad = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    // reset scroll position on new searches
    if (onScroll) onScroll();
  }, [isNewSearchPending, isPendingEhrPatientDemographics, onScroll]);
  const handleCaptchaVerified = isCaptchaVerified => {
    send({
      type: _Actions.CAPTCHA_VERIFIED,
      data: isCaptchaVerified
    });
  };
  const handleCaptchaCancelled = () => {
    send(_Actions.CAPTCHA_CANCELLED);
  };
  const handleCaptchaError = () => {
    send(_Actions.CAPTCHA_ERROR);
  };
  const handleCaptchaReset = () => {
    send(_Actions.CAPTCHA_RESET);
  };
  if (isFetchingAltProviders || isLoadingAvailableLocsPending || isNewSearchPending || isNewSearchRouting || isPendingEhrPatientDemographics || isCheckingCaptchaSession) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, {
      "data-testid": "ApptTime"
    }, /*#__PURE__*/_react.default.createElement(_Loading.default, null));
  }
  const phone = (0, _configUtils.shouldHideSchedulingHelpMessages)(config) ? '' : (0, _utils.getMainContactNumber)(provider);
  if (state.matches(`${_States.newSearch}.${_States.noResults}`) || state.matches(`${_States.loadingAvailableLocs}.${_States.loadingAvailableLocsError}`)) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, {
      "data-testid": "ApptTime"
    }, /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
      phone: phone
    }));
  }
  if (state.matches(`${_States.newSearch}.${_States.verifyingCaptcha}`)) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, {
      "data-testid": "ApptTime"
    }, /*#__PURE__*/_react.default.createElement(_Recaptcha.RecaptchaModal, {
      onCancel: handleCaptchaCancelled,
      onVerified: handleCaptchaVerified,
      onError: handleCaptchaError,
      siteKey: config.recaptchaSiteKey
    }));
  }
  if (state.matches(`${_States.newSearch}.${_States.verifyingCaptchaError}`)) {
    return /*#__PURE__*/_react.default.createElement(_Recaptcha.RecaptchaErrorModal, {
      onClose: handleCaptchaCancelled,
      onReset: handleCaptchaReset
    });
  }
  const selectedLocationIds = new _set.default(query.locationIds);
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "ApptTime"
  }, (0, _configUtils.isDirectBookRenderedInDrawer)(config) ? /*#__PURE__*/_react.default.createElement(_CollapsibleFilters.CollapsibleFilters, {
    id: "appt-time-filters",
    config: config,
    onCollapse: onScroll,
    offsetTop: offsetTop,
    initialState: {
      filterCount,
      selectedLocationIds,
      highlightedLocId,
      locationId,
      visit_method: query.purpose.visit_method,
      locsByAvailability,
      mapUrl: mapApiKey && (0, _utils.buildMapUrl)(mapApiKey),
      date: jumpedToDate,
      dayOfWeek: (0, _from.default)(filterBy.dayOfWeek),
      timeOfDay: (0, _from.default)(filterBy.timeOfDay)[0]
    },
    onSelectedLocationChange: () => {
      send(_Actions.RESET_LOCATION_FILTER);
      track(_Tracking.userEvents.APPT_CHANGE_LOC);
    },
    onDayOfWeekChange: () => {
      track(_Tracking.userEvents.APPT_CHANGE_DAY);
    },
    onTimeOfDayChange: () => {
      track(_Tracking.userEvents.APPT_CHANGE_TIME);
    },
    onDateChange: () => {
      track(_Tracking.userEvents.APPT_JUMP_TO_DATE, {
        patient_rel: query.patientRel,
        purpose: query.purpose.name,
        loaded_appointments_count: appointments.length
      });
    },
    onClearFilters: () => send(_Actions.CLEAR_ALL_FILTERS),
    onApplyFilters: state => {
      send([{
        type: _Actions.SET_ALL_FILTERS,
        data: {
          locationIds: (0, _from.default)(state.selectedLocationIds),
          currentId: state.locationId,
          dayOfWeek: new _set.default(state.dayOfWeek),
          timeOfDay: new _set.default(state.timeOfDay === _TimeFilter.TIME_OF_DAY.ALL ? [] : [state.timeOfDay]),
          periodStart: state.date
        }
      }]);
    }
  }) : /*#__PURE__*/_react.default.createElement(_styles.MapContainer, {
    "data-testid": "Map"
  }, (0, _utils.hasAnyVideoPhoneAppt)(query.purpose.visit_method) ? /*#__PURE__*/_react.default.createElement(_styles.ApptTimeLeftContainer, null, /*#__PURE__*/_react.default.createElement(_VisitTypeContent.default, {
    type: query.purpose.visit_method
  })) : /*#__PURE__*/_react.default.createElement(_styles.MapContent, null, /*#__PURE__*/_react.default.createElement(_ProviderLocations.default, {
    selectedLocationIds: selectedLocationIds,
    highlightedLocId: highlightedLocId,
    url: mapApiKey && (0, _utils.buildMapUrl)(mapApiKey),
    bookableLocations: locsByAvailability.bookable,
    nonBookableLocations: locsByAvailability.nonBookable,
    onSelect: (ids, currentId) => {
      track(_Tracking.userEvents.APPT_CHANGE_LOC);
      send(_Actions.RESET_LOCATION_FILTER);
      send({
        type: _Actions.UPDATE_APPT_QUERY,
        data: {
          locationIds: (0, _from.default)(ids),
          currentId
        }
      });
    },
    locationId: locationId,
    mapEventsToRegister: {
      bounds_changed: mapRef => {
        // set current map zoom value
        getMapZoomRefOnLoad.current = mapRef.current.zoom;
      },
      zoom_changed: mapRef => {
        const zoom = mapRef.current.zoom;
        const value = getMapZoomRefOnLoad.current;
        value && zoom && (value > zoom ? track('user_action.direct_book.appt_time.map_zoom_out') : track('user_action.direct_book.appt_time.map_zoom_in'));
      }
    },
    config: config,
    awsMapConfig: awsMapConfig
  }))), /*#__PURE__*/_react.default.createElement(_ApptList.default, {
    apptDensity: apptDensity,
    provider: provider,
    config: config,
    query: query,
    currentState: state,
    appointments: appointments,
    locations: locsByAvailability.bookable,
    onHighlightLocId: id => setHighLightedLocId(id),
    onClearFilters: () => send((0, _configUtils.isDirectBookRenderedInDrawer)(config) ? _Actions.CLEAR_ALL_FILTERS : _Actions.CLEAR_FILTERS),
    onDayOfWeekChange: dayOfWeek => {
      track(_Tracking.userEvents.APPT_CHANGE_DAY);
      send({
        type: _Actions.SET_LOCAL_FILTER,
        data: {
          dayOfWeek
        }
      });
    },
    onTimeOfDayChange: timeOfDay => {
      track(_Tracking.userEvents.APPT_CHANGE_TIME);
      send({
        type: _Actions.SET_LOCAL_FILTER,
        data: {
          timeOfDay
        }
      });
    },
    onLoadMore: () => {
      track(_Tracking.userEvents.APPT_LOAD_MORE, {
        patient_rel: query.patientRel,
        purpose: query.purpose.name,
        loaded_appointments_count: appointments.length
      });
      send({
        type: _Actions.LOAD_MORE,
        data: {
          periodStart: nextPeriodStart(appointments)
        }
      });
    },
    onSelectAppt: appointment => send({
      type: _Actions.SELECT_APPOINTMENT,
      data: {
        appointment
      }
    }),
    onDateChange: date => {
      track(_Tracking.userEvents.APPT_JUMP_TO_DATE, {
        patient_rel: query.patientRel,
        purpose: query.purpose.name,
        loaded_appointments_count: appointments.length
      });
      send({
        type: _Actions.JUMP_TO_DATE,
        data: {
          periodStart: date.format('YYYY-MM-DD')
        }
      });
    },
    track: track
  }));
}
ApptTime.propTypes = propTypes;
ApptTime.defaultProps = defaultProps;
ApptTime.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptTime",
  "props": {
    "mapApiKey": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "config": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "recaptchaSiteKey": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "apptDensity": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'dense'",
          "computed": false
        }]
      },
      "required": false
    },
    "onScroll": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "offsetTop": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "awsMapConfig": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};